import { ChangeDetectionStrategy, Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'mc-maximize-dialog-button',
  templateUrl: './maximize-dialog-button.component.html',
  styleUrls: ['./maximize-dialog-button.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class MaximizeDialogButtonComponent implements OnInit {
  @Input() dialogRef: MatDialogRef<any>;
  @Input() maximized?: boolean = false;

  fontIcon: string = 'icon-maximize';
  originalWidth: string;
  originalHeight: string;

  constructor() { }

  ngOnInit(): void {
    this.originalWidth = this.dialogRef._containerInstance._config.width;
    this.originalHeight = this.dialogRef._containerInstance._config.height;

    if (this.maximized) {
      this.maximize();
    }
  }

  onResize() {
    this.maximized = !this.maximized;

    if (this.maximized) {
      this.maximize();
    } else {
      this.minimize();
    }
  }

  private maximize() {
    this.dialogRef.updateSize('100%', '100%');
    this.fontIcon = 'icon-minimize';
  }

  private minimize() {
    this.dialogRef.updateSize(this.originalWidth, this.originalHeight);
    this.fontIcon = 'icon-maximize';
  }
}
